import React, { useCallback } from 'react'
import { useMemoRequest } from '../../../../hooks/useMemoRequest'
import api from '../../../../services/api'
import Banner from '../../../atoms/banner/Banner'
import LoadingSpinner from '../../../atoms/loadingspinner/LoadingSpinner'
import { SelectedView, Dropzone } from '../../../organisms/draganddrop'
import { summaryMetricItems } from '../../simulations/steps/summary/data'
import { DragDropContext } from 'react-beautiful-dnd'

const noop = () => {}

function SummaryMetrics () {
  const getSummaryMetricConfig = useCallback(async () => {
    return await api.getSummaryMetricConfig()
  }, [])

  const { data: summaryMetricConfig, inProgress, error } = useMemoRequest(getSummaryMetricConfig)

  const handleSummaryMetricConfigUpdate = useCallback(async (metricConfigId: string, data: Partial<API.SummaryMetricConfig>) => {
    await api.updateSummaryMetricConfig(metricConfigId, data)
  }, [])

  const updateField = useCallback((metricConfigId: string) => (field: string) => (value: string) => {
    handleSummaryMetricConfigUpdate(metricConfigId, {
      [field]: value
    })
  }, [handleSummaryMetricConfigUpdate])

  const items = (summaryMetricConfig ?? []).map(metricConfig => {
    const item = summaryMetricItems.find(item => item.type === metricConfig.type)

    return {
      id: metricConfig.type,
      view: <SelectedView
        label={metricConfig.name}
        icon={item?.icon}
        onUpdateField={updateField(metricConfig.id)}
      />
    }
  })

  return (
    <>
      <h3>Summary Metric Settings</h3>
      {inProgress && <LoadingSpinner />}
      {error && <Banner type='error' active={!!error} message={error?.message} />}
      {summaryMetricConfig &&
          <DragDropContext onDragEnd={noop}>
            <Dropzone items={items} size={items.length} itemsPerPage={items.length} readOnly />
          </DragDropContext>
      }
    </>
  )
}

export default SummaryMetrics
